import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";

import {VenueCardVerification} from "./venue-card-verification.data";
import {Subscription} from "rxjs";

@Component({
    selector: "fhm-venue-card-verification",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-card-verification.component.html",
    styleUrls: ["./venue-card-verification.component.scss"],
    standalone: false
})
export class VenueCardVerificationComponent implements OnInit, OnDestroy {

    data: VenueCardVerification;

    editing: boolean;

    subscription: Subscription = new Subscription();

    constructor(private errorHandler: ErrorHandlerService,
                public model: CustomerInstanceVenueModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscription.add(this.model.data$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
            this.data = this.model.draft ? this.model.data.cardVerification : Object.assign({}, this.model.data.cardVerification);
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    async save(): Promise<void> {
        try {
            await this.model.saveCardVerification(this.data);
            this.editing = false;
        } catch (e) {
            this.errorHandler.handleErrorResponse(e);
        }
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        this.data = Object.assign({}, this.model.data.cardVerification);
        this.editing = false;
    }

}
